<template>
  <div class="daily-summary mt-2" v-if="totalPersonDayWork.SelectedDay">
    <box :title="$t('SummaryInformation')">
      <div>
        <v-row class="pa-2 ma-0">
          <v-col cols="12" sm="6" md="4" lg="2">
            {{ $t("SelectedDaysCount") }}:
            <span class="eos-value">{{ totalPersonDayWork.SelectedDay }}</span>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            {{ $t("TotalWork") }} :
            <span class="eos-value">{{ totalPersonDayWork.TotalWork }}</span>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            {{ $t("TotalKasrKar") }} :
            <span class="eos-value">{{ totalPersonDayWork.TotalKasrKar }}</span>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            {{ $t("TotalEzafeKar") }} :
            <span class="eos-value">{{
              totalPersonDayWork.TotalEzafeKar
            }}</span>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            {{ $t("TotalMorakhasi") }} :
            <span class="eos-value">{{
              totalPersonDayWork.TotalMorakhasi
            }}</span>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="2">
            {{ $t("TotalMission") }} :
            <span class="eos-value">{{ totalPersonDayWork.TotalMission }}</span>
          </v-col>
        </v-row>
      </div>
    </box>
  </div>
</template>

<script>
import Box from "../../widget/Box.vue";
export default {
  components: { Box },
  props: {
    totalPersonDayWork: Object,
  },
  data() {
    return {};
  },
};
</script>

<style scopped>
.functionality-title {
  background: var(--color-primary);
  color: #f2f2f2;
}
</style>